export const FOB_TICKET_PLACED_BET_TYPE = 'Place - Fixed'
export const TOTE_TICKET_PLACED_BET_TYPE = 'Place - Tote'

export const LoadBetErrors = {
  Default: "Sorry, we're unable to create bet",
  BettingClosed: 'Sorry, betting is closed',
} as const
